import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useLocation, useNavigate } from 'react-router-dom';
import { API, axios } from '../utils/api';
import { CATEGORIE } from '../utils/documenti';
import Icona from '../components/cliente/Icone';
import ModuliContratti from '../components/impostazioni/ModuliContratti';
import RubricaBanche from '../components/impostazioni/RubricaBanche';
import ProvvigioniStandard from '../components/impostazioni/Provvigioni';
import ImpostazioniMutui from '../components/impostazioni/Mutui';
import Modelli from '../components/impostazioni/Modelli';
import Comunicazioni from '../components/impostazioni/Comunicazioni';
import Testi from '../components/impostazioni/Testi';
import ImpostazioniTuttofare from '../components/staff/ImpostazioniTuttofare';
import LavoriAutomatici from '../components/impostazioni/LavoriAutomatici';
import RicontrolliCandidate, { ArchivioAutomatico } from '../components/impostazioni/RicontrolliCandidate';
import StatoPush from '../components/impostazioni/StatoPush';
import Accessi from '../components/impostazioni/Accessi';
import Cestino from '../components/impostazioni/Cestino';
import RicercaAutomatica from '../components/impostazioni/RicercaAutomatica';
import VerificaFiltri from '../components/impostazioni/VerificaFiltri';
import EstrattoreWidget from '../components/impostazioni/Estrattore';
import PortaliEstrattore from '../components/impostazioni/PortaliEstrattore';
import AttivitaEstrattore from '../components/impostazioni/AttivitaEstrattore';
import Aste from '../components/impostazioni/Aste';
import { CodiciInvito, RegoleConsigli } from '../components/impostazioni/RegoleECodici';
import { errore } from '../components/impostazioni/comuni';
import '../components/staff/scheda.css';
import '../components/staff/impostazioni.css';

// /admin/impostazioni (solo admin), nello stile delle pagine dello staff: diciotto schede — catalogo dei documenti,
// moduli e contratti, modelli di messaggi ed email, comunicazioni (di notte non si disturba il cliente), testi (quelli
// lunghi che legge il cliente, corretti senza codice), marchi delle agenzie, rubrica di banche e notai, provvigioni
// (compenso e percentuali standard), mutui (i parametri dei prospetti di sostenibilità), regole dei consigli, codici invito, estrattore, aste (quello che abbiamo
// imparato dalle aste segnate dallo staff), attività dell'estrattore (cosa sta facendo, coda, storico, contatori),
// tuttofare, stato push (perché una notifica non arriva), accessi, cestino. #nome nell'indirizzo apre quella scheda.

const PROFILI = [['tutti', 'Tutti'], ['dipendente', 'Dipendente'], ['autonomo', 'Autonomo'], ['pensionato', 'Pensionato'], ['extra_ue', 'Extra-UE']];
const NUOVO = { nome: '', categoria: 'redditi', a_cosa_serve: '', chi_carica: 'cliente', scadenza: false, vale_per: ['tutti'], predefinito: false, per_persona: false };

const Catalogo = () => {
  const [dati, setDati] = useState(null);
  const [nuovo, setNuovo] = useState(NUOVO);
  const carica = useCallback(() => axios.get(`${API}/documenti/catalogo`).then((r) => setDati(r.data)).catch(() => setDati({ categorie: [], tipi: [] })), []);
  useEffect(() => { carica(); }, [carica]);
  const aggiungi = async () => {
    try { await axios.post(`${API}/catalogo`, nuovo); toast.success('Aggiunto al catalogo'); setNuovo(NUOVO); carica(); } catch (e) { toast.error(errore(e, 'Non aggiunto')); }
  };
  const disattiva = async (t) => {
    try { await axios.put(`${API}/catalogo/${t.id}`, { disattivato: true }); carica(); } catch (e) { toast.error(errore(e, 'Non tolto')); }
  };
  const cambiaProfilo = (v) => {
    const s = new Set(nuovo.vale_per.filter((x) => x !== 'tutti'));
    if (v === 'tutti') { setNuovo({ ...nuovo, vale_per: ['tutti'] }); return; }
    if (s.has(v)) s.delete(v); else s.add(v);
    setNuovo({ ...nuovo, vale_per: s.size ? [...s] : ['tutti'] });
  };
  const spunta = (k, testo) => (
    <label className="spunta"><input type="checkbox" checked={nuovo[k]} onChange={(e) => setNuovo({ ...nuovo, [k]: e.target.checked })} />{testo}</label>
  );
  if (!dati) return <p className="vuoto">Carico il catalogo…</p>;
  return (
    <div className="imp-griglia" data-testid="catalogo">
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="piu" /></div><h2>Aggiungi un tipo di documento</h2></div>
        <div className="imp-campi">
          <label>Nome<input value={nuovo.nome} placeholder="es. Visura camerale" onChange={(e) => setNuovo({ ...nuovo, nome: e.target.value })} /></label>
          <label>Categoria
            <select value={nuovo.categoria} onChange={(e) => setNuovo({ ...nuovo, categoria: e.target.value })}>
              {Object.entries(CATEGORIE).map(([id, n]) => <option key={id} value={id}>{n}</option>)}
            </select>
          </label>
          <label>Chi lo carica
            <select value={nuovo.chi_carica} onChange={(e) => setNuovo({ ...nuovo, chi_carica: e.target.value })}>
              <option value="cliente">Il cliente (e lo vede)</option><option value="staff">Solo per noi (il cliente non lo vede)</option>
            </select>
          </label>
          <label className="largo">A cosa serve (lo legge il cliente)<input value={nuovo.a_cosa_serve} onChange={(e) => setNuovo({ ...nuovo, a_cosa_serve: e.target.value })} /></label>
        </div>
        <div className="imp-azioni">
          {spunta('scadenza', 'ha una scadenza')}{spunta('predefinito', 'già spuntato alla prima richiesta')}{spunta('per_persona', 'uno per persona')}
        </div>
        <div className="imp-azioni" role="group" aria-label="Vale per">
          <span className="imp-nota">Vale per:</span>
          {PROFILI.map(([v, t]) => (
            <button key={v} type="button" className={`chip${nuovo.vale_per.includes(v) ? ' on' : ''}`} aria-pressed={nuovo.vale_per.includes(v)} onClick={() => cambiaProfilo(v)}>{t}</button>
          ))}
        </div>
        <div className="imp-azioni"><button type="button" className="btn sm p" disabled={nuovo.nome.trim().length < 3} onClick={aggiungi}>Aggiungi</button></div>
      </section>
      {dati.categorie.map((c) => (
        <section key={c.id} className="card">
          <div className="ttl"><div className="i b"><Icona nome="documento" /></div><h2>{c.nome}</h2></div>
          <div className="imp-righe">
            {dati.tipi.filter((t) => t.categoria === c.id).map((t) => (
              <div key={t.id} data-testid={`tipo-${t.id}`}>
                <b>{t.nome}</b>
                {!t.visibile_cliente && <span className="tag t-b">solo per noi</span>}
                {t.periodico && <span className="tag t-o">periodico</span>}
                {t.scadenza && <span className="tag t-w">scade</span>}
                <span className="descr">{t.a_cosa_serve}</span>
                {t.aggiunto && <div className="azioni"><button type="button" className="btn xs rosso-vuoto" onClick={() => disattiva(t)}>Togli</button></div>}
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

const Marchi = () => {
  const [dati, setDati] = useState(null);
  const [righe, setRighe] = useState([]);
  const leggi = (d) => setRighe(d.aggiunti.map((m) => ({ nome: m.nome, varianti: m.varianti.join(', ') })));
  useEffect(() => {
    axios.get(`${API}/impostazioni/marchi`).then((r) => { setDati(r.data); leggi(r.data); }).catch(() => setDati({ base: [], aggiunti: [] }));
  }, []);
  const salva = async () => {
    try {
      const r = await axios.put(`${API}/impostazioni/marchi`, { marchi: righe.filter((m) => m.nome.trim()).map((m) => ({ nome: m.nome, varianti: m.varianti.split(',') })) });
      leggi(r.data);
      toast.success('Marchi salvati');
    } catch (e) { toast.error(errore(e, 'Non salvati')); }
  };
  const cambia = (i, k) => (e) => setRighe(righe.map((x, j) => (j === i ? { ...x, [k]: e.target.value } : x)));
  if (!dati) return <p className="vuoto">Carico i marchi…</p>;
  return (
    <section className="card" data-testid="marchi">
      <div className="ttl"><div className="i"><Icona nome="edificio" /></div><h2>Marchi e franchising</h2></div>
      <p className="imp-nota">Il marchio si riconosce dal nome dell'agenzia. Stesso marchio in un altro comune o con un altro telefono resta un'altra agenzia.</p>
      <div className="imp-azioni">{dati.base.map((m) => <span key={m.nome} className="chip" style={{ cursor: 'default' }}>{m.nome}</span>)}</div>
      <div className="imp-righe" style={{ marginTop: '1rem' }}>
        {righe.map((m, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i}>
            <input className="imp-input" style={{ width: '12rem' }} placeholder="Marchio" value={m.nome} onChange={cambia(i, 'nome')} aria-label="Marchio" />
            <input className="imp-input" style={{ flex: 1, minWidth: '14rem', width: 'auto' }} placeholder="Come si scrive nei nomi, separato da virgole" value={m.varianti}
              onChange={cambia(i, 'varianti')} aria-label="Varianti del marchio" />
            <button type="button" className="btn xs rosso-vuoto" onClick={() => setRighe(righe.filter((_, j) => j !== i))}>Togli</button>
          </div>
        ))}
      </div>
      <div className="imp-azioni">
        <button type="button" className="btn sm" onClick={() => setRighe([...righe, { nome: '', varianti: '' }])}>+ Marchio</button>
        <button type="button" className="btn sm p" onClick={salva}>Salva</button>
      </div>
    </section>
  );
};

// Le schede, in quest'ordine
export const SCHEDE = [
  ['catalogo', 'Catalogo documenti', () => <Catalogo />],
  ['moduli', 'Moduli e contratti', () => <ModuliContratti />],
  ['modelli', 'Modelli messaggi ed email', () => <Modelli />],
  ['comunicazioni', 'Comunicazioni', () => <Comunicazioni />],
  ['testi', 'Testi', () => <Testi />],
  ['marchi', 'Marchi agenzie', () => <Marchi />],
  ['rubrica', 'Rubrica banche e notai', () => <RubricaBanche />],
  ['provvigioni', 'Provvigioni', () => <ProvvigioniStandard />],
  ['mutui', 'Mutui', () => <ImpostazioniMutui />],
  ['consigli', 'Regole dei consigli', () => <RegoleConsigli />],
  ['codici', 'Codici invito', () => <CodiciInvito />],
  ['estrattore', 'Estrattore', () => <div className="imp-griglia"><EstrattoreWidget /><PortaliEstrattore /><RicontrolliCandidate /><ArchivioAutomatico /><RicercaAutomatica /><VerificaFiltri /></div>],
  // #estrattore-attivita: l'ancora che apre il popup dell'estensione (backend/diario_estrattore.py → riepilogo)
  ['estrattore-attivita', 'Attività estrattore', () => <AttivitaEstrattore />],
  ['aste', 'Aste', () => <Aste />],
  ['tuttofare', 'Tuttofare', () => <ImpostazioniTuttofare />],
  ['push', 'Stato push', () => <StatoPush />],
  ['lavori', 'Lavori automatici', () => <LavoriAutomatici />],
  ['accessi', 'Accessi', () => <Accessi />],
  ['cestino', 'Cestino', () => <Cestino />],
];

const Impostazioni = () => {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const scheda = SCHEDE.some(([k]) => k === hash.replace('#', '')) ? hash.replace('#', '') : 'catalogo';
  const Contenuto = SCHEDE.find(([k]) => k === scheda)[2];
  return (
    <main className="st wrap" data-testid="impostazioni">
      <div className="imp-head">
        <div><div className="k">Admin</div><h1>Impostazioni</h1>
          <p>Documenti, moduli, messaggi, comunicazioni, testi, agenzie, banche, provvigioni, consigli, codici, estrattore e la sua
            attività, aste, tuttofare, stato push, accessi e cestino: tutto quello che vale per tutti.</p></div>
      </div>
      <div className="tabs tabs-imp" role="tablist" aria-label="Impostazioni">
        {SCHEDE.map(([k, nome]) => (
          <button type="button" role="tab" key={k} aria-selected={scheda === k} className={scheda === k ? 'on' : undefined}
            onClick={() => navigate(`#${k}`, { replace: true })}>{nome}</button>
        ))}
      </div>
      <div role="tabpanel" aria-label={SCHEDE.find(([k]) => k === scheda)[1]}><Contenuto /></div>
    </main>
  );
};

export default Impostazioni;
